import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./assets/styles/style.css";
import AddNewJob from "./pages/AddNewJob";
import AllFullTimeJob from "./pages/AllFullTimeJob";
import AllInternshipJob from "./pages/AllInternshipJob";
import AllRemoteJob from "./pages/AllRemoteJob";
import EditJob from "./pages/EditJob";
import Home from "./pages/Home";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/addnewjob" element={<AddNewJob />} />
        <Route path="/editjob/:id" element={<EditJob />} />
        <Route path="/jobs/fulltime" element={<AllFullTimeJob />} />
        <Route path="/jobs/internship" element={<AllInternshipJob />} />
        <Route path="/jobs/remote" element={<AllRemoteJob />} />
      </Routes>
    </Router>
  );
}

export default App;
